import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import InputMask from 'react-input-mask';
import withMaskedInput from '../../../HOC/withMaskedInput';

class PhoneField extends Component {
  render() {
    return (
      <div>    
        <FormGroup>
          <Label for="phone">Work Phone</Label>
          <InputMask mask="999-999-9999" value={this.props.phone} onKeyDown={this.props.onKeyDown} onSelect={this.props.onClick} onClick={this.props.onClick} beforeMaskedValueChange={this.props.beforeMaskedValueChange} onChange={this.props.handleChange} onBlur={this.props.validateField}>
            {(inputProps) => <Input name="phone" {...inputProps} id="phone" type="tel" invalid={this.props.validation.phone.isInvalid} autoComplete="tel-national" autoCapitalize="off" autoCorrect="off" />}
          </InputMask>    
          <FormFeedback>{this.props.validation.phone.message}</FormFeedback>
        </FormGroup>
      </div>);
  }
}
PhoneField.defaultProps= {
  handleChange:() => {},
  validation: {
    phone: {
      isInvalid: false,
      message: ""
    }
  }
};

PhoneField.propTypes = {
  handleChange: PropTypes.func,
};

export default withMaskedInput("phone")(PhoneField);


// WEBPACK FOOTER //
// ./src/components/Fields/Occupation/PhoneField.js